import { Component, OnInit, ChangeDetectionStrategy, input } from '@angular/core';
import { EnergyValueBasis } from '@eadsysteme/energyefficiencyclient-v1';
import {
	MatTableDataSource,
	MatTable,
	MatColumnDef,
	MatHeaderCellDef,
	MatHeaderCell,
	MatCellDef,
	MatCell,
	MatHeaderRowDef,
	MatHeaderRow,
	MatRowDef,
	MatRow,
	MatNoDataRow,
} from '@angular/material/table';
import { fadeInUp400ms } from '../../../../../../../@vex/animations/fade-in-up.animation';
import { stagger40ms } from '../../../../../../../@vex/animations/stagger.animation';
import { TranslocoDirective } from '@jsverse/transloco';
import { MatSort } from '@angular/material/sort';
import { DatePipe } from '@angular/common';

@Component({
	selector: 'app-calculation-tables-coldwater',
	templateUrl: './coldwater.component.html',
	styleUrls: ['./coldwater.component.scss'],
	animations: [fadeInUp400ms, stagger40ms],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [
		TranslocoDirective,
		MatTable,
		MatSort,
		MatColumnDef,
		MatHeaderCellDef,
		MatHeaderCell,
		MatCellDef,
		MatCell,
		MatHeaderRowDef,
		MatHeaderRow,
		MatRowDef,
		MatRow,
		MatNoDataRow,
		DatePipe,
	],
})
export class ColdwaterComponent implements OnInit {
	displayedColumns = [
		'deviceNumber',
		'communicationNumber',
		'physicalUnit',
		'beginReadingDate',
		'readingValue1',
		'endReadingDate',
		'readingValue2',
		'readingValueTimeShare',
		'periodTimeShare',
		'monthlyConsumption',
		'unit2KwhConversionFactorForUser',
		'consumption',
	];
	dataSource: MatTableDataSource<EnergyValueBasis>;
	readonly item = input<EnergyValueBasis[]>(undefined);
	readonly data = input('');

	ngOnInit(): void {
		this.dataSource = new MatTableDataSource<EnergyValueBasis>(this.item());
	}
}
